import { ActionTimestamp } from "../../../../action";
import { BrickInventoryEntry } from "../../../../BrickInventory/BrickInventory";
import { BrickPackPurchase } from "../../../../BrickPackHistory/BrickPackPurchase";
import { ActionEntry } from "../../../ActionEntries";

const rollChance = (chance: number): boolean => {
  return Math.random() < chance;
};

export const ApplyOutcomesBrickPack = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newActionTimestamps: ActionTimestamp[],
  totalAmt: number, // total packs purchased
  newBrickPackHistory: Map<string, BrickPackPurchase[]>,
  newBrickPackStats: Map<string, number>,
  brickPackUpgrades: Map<string, number>,
) => {
  if (
    newBrickPackStats.get(action.id) !== undefined &&
    newBrickPackStats.get(action.id) !== null
  ) {
    newBrickPackStats.set(
      action.id,
      (newBrickPackStats.get(action.id) || 0) + totalAmt,
    );
  } else {
    return null;
  }

  let newBrickPackPurchase: BrickPackPurchase = {
    timestamp: new Date(Date.now()).toISOString(),
    totalPacks: totalAmt,
    brickContents: new Map<string, number>(),
  };

  // Track bricks added for achievement stats
  const bricksAdded = new Map<string, number>();

  // Apply Outcomes
  // Repeat for each pack (x1 / x10 / x100)
  for (let k = 0; k < totalAmt; k++) {
    for (let i = 0; i < action.outcome.length; i++) {
      // For BrickPack's baseChangeValue is the Find Percentage value
      const basePercentage = action.outcome[i].baseChangeValue;

      // Get upgrade bonus (number of upgrades * 0.05)
      const upgradeCount = brickPackUpgrades.get(action.id) || 0;
      const upgradeBonus = upgradeCount * 0.05;

      // Calculate final roll percentage, capped at 1.0 (100%)
      const rollPercentage = Math.min(1.0, basePercentage + upgradeBonus);

      const currBrick = newBricks.get(action.outcome[i].brickId)!;

      if (rollChance(rollPercentage)) {
        if (Number.isNaN(currBrick.amount)) currBrick.amount = 0;

        // Check if brick has capacity before adding
        const hadCapacity = currBrick.amount < currBrick.capacity;

        currBrick.amount = Math.min(currBrick.capacity, currBrick.amount + 1);

        // Only track if brick was actually added (had capacity)
        if (hadCapacity) {
          // Track bricks added for achievements
          const currentCount = bricksAdded.get(currBrick.id) || 0;
          bricksAdded.set(currBrick.id, currentCount + 1);

          // Update BrickPack History
          if (newBrickPackPurchase.brickContents.get(currBrick.id)) {
            // Update existing entry - increment brick count
            newBrickPackPurchase.brickContents.set(
              currBrick.id,
              (newBrickPackPurchase.brickContents.get(currBrick.id) || 0) + 1,
            );
          } else {
            // Create new entry
            newBrickPackPurchase.brickContents.set(currBrick.id, 1);
          }

          const timestamp: ActionTimestamp = {
            id: currBrick.id,
            amount: 1,
            timestamp: Date.now(),
          };

          newActionTimestamps.push(timestamp);
        }
      }
    }
  }

  const history = newBrickPackHistory.get(action.id);

  if (history) {
    if (history.length === 10) history.pop();

    history.unshift(newBrickPackPurchase);
  } else {
    return null;
  }

  return { newBricks, bricksAdded };
};
